import type { SVGProps } from "react";

export function IconVideoChevronRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="14"
      viewBox="0 0 8 14"
      width="8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video chevron right</title>
      <path
        d="M1 1 L7 7 L1 13"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
